import { render, staticRenderFns } from "./Userdetail.vue?vue&type=template&id=07aec798&scoped=true"
import script from "./Userdetail.vue?vue&type=script&lang=js"
export * from "./Userdetail.vue?vue&type=script&lang=js"
import style0 from "./Userdetail.vue?vue&type=style&index=0&id=07aec798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aec798",
  null
  
)

export default component.exports